// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"57":"Server","268":"Home","386":"Clients","614":"Status"}[chunkId] || chunkId) + "." + {"57":"94afc75e","268":"73cb3b72","386":"d8d452d8","567":"d24db7da","614":"508a9358","887":"88db22da"}[chunkId] + ".js";
};